export class DescriptionResponse {
  descriptionResponseId: string;
  descriptionResponseName: string;
  dateCreated: Date;
  dateModified: Date;
  subscriberId: string;
  siteId: string;
  id: string;
}
